import React, { useEffect, useMemo, useState } from 'react';
import { SimpleModal, TimerOutline } from '@4r/module-common-ant-components';
import {
  ENTERPRISE_CONTRACT_EVENT,
  I4EnterpriseContracts,
} from '@4r/mf-contracts';
import { AttendanceActionDto, AttendanceClient } from '@@api';
import { ATTENDANCE_TYPE_ID, RECORD_ID, getMessageBusService } from '@@common';
import {
  useOfflineCommand,
  useOfflineLoadOrGet,
} from '@4r/module-common-mf-app';
import { useApiClient } from '@@hooks';
import PermissionType from '../../authorization/PermissionType';
import clockAction from '../../services/clockAction';

const menu: I4EnterpriseContracts = {
  TimeAttendanceMicrofrontend: {
    priority: 0,
    channels: ['4Services'],
    leftMenus: {
      webClock: {
        title: 'Web Clock',
        priority: -1,
        icon: <TimerOutline />,
        anyPermissions: [PermissionType.ViewWebClock],
        route: '/time-attendance/web-clock',
      },
    },
  },
};

const StatusCheckerView: React.FC<any> = () => {
  const attendanceClient = useApiClient(AttendanceClient);
  const [modalVisible, setModalVisible] = useState(false);
  const [firstCheckHappened, seFirstCheckHappened] = useState(false);

  const [currentEmployee] = useOfflineLoadOrGet(
    RECORD_ID.USER_ATTENDANCE_STATUS,
    attendanceClient,
    (s) => s.currentEmployee(),
  );

  const [, submitCommand] = useOfflineCommand();

  const isTimeEntryRequired = useMemo(
    () => currentEmployee?.isTimeEntryRequired ?? false,
    [currentEmployee],
  );

  useEffect(() => {
    if (isTimeEntryRequired) {
      // add additional menu options
      getMessageBusService().emit(ENTERPRISE_CONTRACT_EVENT, menu);
    }
  }, [isTimeEntryRequired]);

  useEffect(() => {
    const forceClockIn = async (possibleActions: AttendanceActionDto[]) => {
      await clockAction(
        submitCommand,
        possibleActions,
        ATTENDANCE_TYPE_ID.CLOCK_IN,
      );
      setModalVisible(true);
    };

    if (isTimeEntryRequired && currentEmployee && !firstCheckHappened) {
      // prevent from clock in to be forced again
      seFirstCheckHappened(true);

      // check if user opened app and if is clocked out - then attempt to clock in
      if (
        !currentEmployee.lastEvent ||
        currentEmployee.lastEvent.typeId === ATTENDANCE_TYPE_ID.CLOCK_OUT
      ) {
        forceClockIn(currentEmployee.possibleActions);
      }
    }
  }, [
    currentEmployee,
    firstCheckHappened,
    submitCommand,
    setModalVisible,
    isTimeEntryRequired,
  ]);

  // nothing to display
  return (
    <SimpleModal
      title="Clock in / Clock out"
      isVisible={modalVisible}
      onConfirm={() => setModalVisible(false)}
      onCancel={() => setModalVisible(false)}
      okButtonOnly={true}
    >
      You have just logged into 4Services and also clocked in!
    </SimpleModal>
  );
};

export default StatusCheckerView;
